<template>
  <v-dialog v-model="dialogEdit" persistent max-width="1200px">
      <v-card>
        <!-- <v-card-title>
          <span class="headline">{{textTitle}}</span>
        </v-card-title> -->
        <v-card-text>
          <v-container>
            <div class="text-right">
              <v-btn class="ma-2" outlined small fab color="green" v-if="valueAction === true" @click="switeAction(false)">
                <v-icon >mdi-pencil</v-icon>
              </v-btn>
              <v-btn class="ma-2" outlined small fab color="indigo" v-if="valueAction === true" @click="switeAction(true)">
                <v-icon >mdi-pencil</v-icon>
              </v-btn>
            </div>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <h2 class="txt-head" style="margin-top: -1%">แก้ไขข้อมูลบริษัท</h2>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-layout class="container-card pa-5 pr-5 mt-2">
                  <v-row>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อเครือ</p>
                      <v-select
                        v-model="groupName"
                        :items="itemCompany"
                        item-text="groupCompanyNameEng"
                        item-value="_id"
                        label="เลือก เครือ"
                        dense
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(ไทย)*</p>
                      <v-text-field
                        v-model="companyNameShortTh"
                        label="ชื่อย่อบริษัท(ไทย)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อย่อบริษัท(อังกฤษ)*</p>
                      <v-text-field
                        v-model="companyNameShortEng"
                        label="ชื่อย่อบริษัท(อังกฤษ)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(ไทย)*</p>
                      <v-select
                        v-model="legalEntityTh"
                        :items="['ห้างหุ่นส่วนสามัญ', 'ห้างหุ่นส่วนจำกัด', 'บริษัทจำกัด', 'บริษัทมหาชนจำกัด', 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ']"
                        label="กรุณาเลือกประเภทนิติบุคคล(ไทย)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(ไทย)*</p>
                      <v-text-field
                        v-model="companyNameFullTh"
                        label="ชื่อบริษัท(ไทย)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(ไทย)*</p>
                      <v-text-field
                        v-model="nameUseInDocTh"
                        label="ชื่อสำหรับแสดงบนเอกสาร(ไทย)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ประเภทนิติบุคคล(อังกฤษ)*</p>
                      <v-select
                        v-model="legalEntityEng"
                        :items="['Ordinary Partnership', 'Limited Partnership', 'Company Limited', 'Public Limited Company', 'Other']"
                        label="Please choose a legal entity"
                        dense
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อเต็มบริษัท(อังกฤษ)*</p>
                      <v-text-field
                        v-model="companyNameFullEng"
                        label="ชื่อบริษัท(อังกฤษ)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)*</p>
                      <v-text-field
                        v-model="nameUseInDocEng"
                        label="ชื่อสำหรับแสดงบนเอกสาร(อังกฤษ)"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-layout>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-layout class="container-card pa-5 pr-5">
                  <v-row>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">เลขที่ผู้เสียภาษีอากร*</p>
                      <v-text-field
                        v-model="taxId"
                        label="เลขที่ผู้เสียภาษีอากร"
                        :rules="inputRules"
                        type="number"
                        maxlength="13"
                        required
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">อีเมล*</p>
                      <v-text-field
                        v-model="email"
                        :rules="inputRules"
                        label="อีเมล"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ภูมิภาค/Region*</p>
                      <v-select
                        v-model="region"
                        :items="['Northern', 'Northeastern', 'Central', 'Southern']"
                        label="Please choose a legal entity"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-select>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">ชื่อสาขา*</p>
                      <v-text-field
                        v-model="branchName"
                        label="ชื่อสาขา"
                        :rules="inputRules"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">รหัสสาขา*</p>
                      <v-text-field
                        v-model="branchCode"
                        label="รหัสสาขา"
                        :rules="inputRules"
                        type="number"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">เบอร์โทรศัพท์</p>
                      <v-text-field
                        v-model="companyTelNo"
                        label="เบอร์โทรศัพท์"
                        type="number"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">เบอร์มือถือ*</p>
                      <v-text-field
                        v-model="companyMobilNumber"
                        label="เบอร์มือถือ"
                        :rules="inputRules"
                        type="number"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" class="form-control">
                      <p class="txt-font" style="margin-top: 0%;">โทรสาร</p>
                      <v-text-field
                        v-model="fax"
                        label="เบอร์โทรสาร"
                        type="number"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-layout>
              <v-layout class="container-card pa-5 pr-5 mt-5">
                <v-row>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">เลขรหัสประจำที่อยู่</p>
                    <v-text-field
                      v-model="companyAddressDetail.codeAddress"
                      label="เลขรหัสประจำที่อยู่"
                      type="number"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ที่อยู่*</p>
                    <v-text-field
                      v-model="companyAddressDetail.address"
                      label="ที่อยู่"
                      :rules="inputRules"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ห้องเลขที่</p>
                    <v-text-field
                      v-model="companyAddressDetail.roomNo"
                      label="ห้องเลขที่"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ชั้นที่</p>
                    <v-text-field
                      v-model="companyAddressDetail.floorNo"
                      label="ชั้นที่"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">อาคาร</p>
                    <v-text-field
                      v-model="companyAddressDetail.buildingName"
                      label="อาคาร"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">หมู่บ้าน</p>
                    <v-text-field
                      v-model="companyAddressDetail.villageName"
                      label="หมู่บ้าน"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">หมู่ที่</p>
                    <v-text-field
                      v-model="companyAddressDetail.villageNo"
                      label="หมู่ที่"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ตรอก/ซอย</p>
                    <v-text-field
                      v-model="companyAddressDetail.alley"
                      label="ตรอก/ซอย"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">แยก</p>
                    <v-text-field
                      v-model="companyAddressDetail.dispart"
                      label="แยก"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ถนน</p>
                    <v-text-field
                      v-model="companyAddressDetail.road"
                      label="ถนน"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">จังหวัด*</p>
                    <v-select
                      v-model="companyAddressDetail.province"
                      :items="$store.state.province_th"
                      item-text="groupCompanyNameEng"
                      item-value="_id"
                      label="กรุณาเลือกจังหวัด"
                      :rules="inputRules"
                      dense
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">อำเภอ/เขต*</p>
                    <v-text-field
                      v-model="companyAddressDetail.district"
                      label="อำเภอ/เขต"
                      :rules="inputRules"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">ตำบล/แขวง*</p>
                    <v-text-field
                      v-model="companyAddressDetail.subDistrict"
                      label="ตำบล/แขวง"
                      :rules="inputRules"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="form-control">
                    <p class="txt-font" style="margin-top: 0%;">รหัสไปรษณีย์*</p>
                    <v-text-field
                      v-model="companyAddressDetail.postCode"
                      label="รหัสไปรษณีย์"
                      :rules="inputRules"
                      type="number"
                      dense
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <p class="txt-font" style="margin-top: 0%;">รูปภาพ*</p>
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-img
                          v-bind="attrs"
                          v-on="on"
                          class="base-image-input"
                          :src="imageUrl"
                          v-on:error="onImgErrorLeader"
                          aspect-ratio="2.7"
                          @click="ChooseBanner()"
                        >
                        <template v-slot:placeholder>
                          <v-img :src="require('@/assets/icons/add_company2.png')" />
                        </template>
                          <span
                            v-if="!imageUrl"
                            class="placeholder"
                          >
                            เลือกรูปภาพ
                          </span>
                          <input
                            class="file-input"
                            id="files"
                            ref="Pickfiles"
                            type="file"
                            v-on:change="onBannerSelected()"
                          >
                        </v-img>
                      </template>
                      <span class="txt-font" v-if="imageUrl !== ''" >กดอีกครั้งเพื่อเลือกรูปใหม่</span>
                      <span class="txt-font" v-if="imageUrl === ''">กดเพื่อเลือกรูป</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-layout>
            </v-form>
            <v-divider
              class="mx-15 mr-5"
              style="margin-top: 2%; margin-bottom: 2%;"
              inset
              herizontal
            ></v-divider>
            <v-row class="mt-3 px-5 align-center">
              <span class="manage-department-title">เพิ่มผู้ดูแล</span>
              <v-btn
                right
                rounded
                color="green"
                dark
                class="mr-2 ml-5 pa-5 align-center"
                @click="getUserDefault()"
              >
              <v-icon left dark color="white">fa-plus-circle</v-icon>
                <span class="txt-font">เพิ่มตัวเอง</span>
              </v-btn>
              <v-btn
                right
                rounded
                color="green"
                dark
                class="mr-2 ml-0 pa-5 align-center"
                @click="openDialogAddAprover('add', '', '')"
              >
              <v-icon left dark color="white">fa-plus-circle</v-icon>
                <span class="txt-font">เพิ่มผู้อื่น</span>
              </v-btn>
            </v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="pa-0">
              <v-row>
                <v-col
                  v-for="(item, i) in approver"
                  :key="i"
                  cols="6"
                  class="elevation-2"
                  align="center"
                  style="border: 2px;
                  border-radius: 15px;"
                >
                  <div
                    class="card-header-user pa-3"
                  >
                    <v-row>
                      <v-col cols="4" sm="12" md="4" lg="4">
                        <v-avatar
                          size="150"
                          rounded
                          >
                          <v-img
                            class="card-header-userimg-border"
                            cover
                            :lazy-src="require('@/assets/icons/no_user.png')"
                            :src="item.failed_image ? require('@/assets/icons/no_user.png') : item.userImg"
                            :alt="item.employeeId"
                            v-on:error="onImgError(i)"
                            aspect-ratio="1"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col cols="8" sm="12" md="8" lg="8" class="pl-3 pr-3">
                        <v-row class="align-center">
                          <h3 class="txt-head pl-3">ลำดับที่ {{ i+1 }}</h3>
                          <v-spacer/>
                          <v-btn
                            rounded
                            color="#2196F3"
                            dark
                            icon
                            class="btn-edit-dep mb-3 mr-1"
                            @click="openDialogAddAprover('edit', item, i)">
                            <v-icon dark color="white" small>fa-wrench</v-icon>
                          </v-btn>
                          <v-btn
                            rounded
                            color="#2196F3"
                            dark
                            icon
                            class="btn-del-dep mb-3 mr-3"
                            @click="checkRemove(item)">
                            <v-icon dark color="white" small>fa-trash</v-icon>
                          </v-btn>
                        </v-row>

                        <v-row>
                          <v-col cols="4" sm="6" md="4" lg="4" class="text-start pr-0 pt-0 pb-0">
                            <span class="txt-font">รหัสพนักงาน: </span>
                          </v-col>
                          <v-col cols="8" sm="6" md="8" lg="8" class="text-start pt-0 pb-0">
                            <span class="txt-font"> {{item.employeeId || '-'}}</span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="4" sm="6" md="4" lg="4" class="text-start pr-0 pt-0 pb-0">
                            <span class="txt-font">ชื่อ: </span>
                          </v-col>
                          <v-col cols="8" sm="6" md="8" lg="8" class="text-start pt-0 pb-0">
                            <span class="txt-font"> {{item.approverName || '-'}}</span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="4" sm="6" md="4" lg="4" class="text-start pr-0 pt-0 pb-0">
                            <span class="txt-font">ตำแหน่ง: </span>
                          </v-col>
                          <v-col cols="8" sm="6" md="8" lg="8" class="text-start pt-0 pb-0">
                            <span class="txt-font"> {{item.position || '-'}}</span>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="4" sm="6" md="4" lg="4" class="text-start pr-0 pt-0">
                            <span class="txt-font">อีเมล: </span>
                          </v-col>
                          <v-col cols="8" sm="6" md="8" lg="8" class="text-start pt-0">
                            <span class="txt-font"> {{item.email || item.emailOneId || '-'}}</span>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <h2 class="txt-head">
              ดาวน์โหลดแบบฟอร์ม
            </h2>
            <v-layout class="row ml-10">
              <v-col cols="3" class="form-control">
                <v-btn
                  id="btnbrowse"
                  name="btnbrowse"
                  right
                  rounded
                  color="primary"
                  dark
                  class="mr-2 ml-5 pa-5 align-center btn_click"
                  @click="getFormAuth()"
                >
                <v-icon left dark color="white">fa-download</v-icon>
                  <span class="txt-font">ฟอร์มหนังสือมอบอำนาจ</span>
                </v-btn>
              </v-col>
              <v-col cols="2" class="form-control">
                <v-btn
                  id="btnbrowse"
                  name="btnbrowse"
                  right
                  rounded
                  color="primary"
                  dark
                  class="mr-2 ml-10 pa-5 align-center btn_click"
                  @click="getFormPoa()"
                >
                <v-icon left dark color="white">fa-download</v-icon>
                  <span class="txt-font">ฟอร์มหนังสือมอบอำนาจช่วง</span>
                </v-btn>
              </v-col>
            </v-layout>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <h2 class="txt-head">
              เพิ่มไฟล์เอกสาร
            </h2>
            <v-row>
              <v-col cols="4" class="box-image2">
                <v-btn
                  id="btnbrowse"
                  name="btnbrowse"
                  right
                  rounded
                  color="green"
                  dark
                  class="mr-2 ml-5 pa-5 align-center btn_click"
                  v-on:click="addFiles('certificate')"
                >
                <v-icon left dark color="white">fa-upload</v-icon>
                  <span class="txt-font">หนังสือรองรับนิติบุคคล(PDF)</span>
                </v-btn>
                <input type="file" id="files" ref="PickfilesCertificate" multiple v-on:change="onFileSelected('certificate')"/>
                <div v-for="(file, key) in filesCertificate" :name="file.name" class="file-listing ml-5 mt-2" :key="key">
                  <v-icon left dark color="red">fa-file-pdf</v-icon>
                  <v-chip close :id="key" :name="file.name" @click:close="removeFile(key, 'certificate')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</v-chip>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="box-image2 mt-5">
                <v-btn
                  id="btnbrowse"
                  name="btnbrowse"
                  right
                  rounded
                  color="green"
                  dark
                  class="mr-2 ml-5 pa-5 align-center btn_click"
                  v-on:click="addFiles('poa')"
                >
                <v-icon left dark color="white">fa-upload</v-icon>
                  <span class="txt-font">หนังสือมอบอำนาจช่วง(PDF)</span>
                </v-btn>
                <input type="file" id="files" ref="PickfilesPoa" multiple v-on:change="onFileSelected('poa')"/>
                <div v-for="(file, key) in filesPoa" :name="file.name" class="file-listing ml-5 mt-2" :key="key">
                  <v-icon left dark color="red">fa-file-pdf</v-icon>
                  <v-chip close :id="key" :name="file.name" @click:close="removeFile(key, 'poa')" color=""><strong class="txt-font">{{ file.name }}</strong>&nbsp;</v-chip>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-0 mb-2" color="success" outlined dark @click="closeDialogEdit()">ยกเลิก</v-btn>
          <v-btn class="mr-3 mb-2" color="success" @click="submitEdit()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    <DialogAddAprover/>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import DialogAddAprover from '../manageCompany/_dialog/dialogAddApprover'
import { getUserByKeyword, hostImageUrlv3 } from '@/API/API'
import FileSaver from 'file-saver'

export default {
  components: {
    DialogAddAprover
  },
  data () {
    return {
      valueAction: false,
      dialogEdit: false,
      failed_imageLeader: false,
      textTitle: '',
      preName: '',
      companyId: '',
      imageData: null,
      itemCompany: ['INET', 'OGS'],
      legalEntityTh: '',
      legalEntityEng: '',
      nameUseInDocTh: '',
      nameUseInDocEng: '',
      groupName: '',
      companyNameEng: '',
      companyNameTh: '',
      taxId: '',
      email: '',
      branchName: '',
      branchCode: '',
      companyTelNo: '',
      companyMobilNumber: '',
      region: '',
      fax: '',
      companyAddressDetail: {
        codeAddress: '',
        address: '',
        roomNo: '',
        floorNo: '',
        buildingName: '',
        villageName: '',
        villageNo: '',
        alley: '',
        dispart: '',
        road: '',
        province: '',
        district: '',
        subDistrict: '',
        postCode: ''
      },
      companyNameFullEng: '',
      companyNameFullTh: '',
      companyNameShortEng: '',
      companyNameShortTh: '',
      address: '',
      files: [],
      filesCertificate: [],
      filesPoa: [],
      filesPoaName: '',
      filesAuth: [],
      tel: '',
      img: '',
      image: '',
      imageUrl: '',
      tokenUser: '',
      type_files: ['pdf', 'png', 'jpg', 'jpeg', 'tiff', 'gif', 'rar', 'zip', '7z'],
      userIdList: [],
      approver: [
        // {
        //   no: 1,
        //   _id: '1212xx',
        //   employeeId: 'sittikorn0993',
        //   nameTH: 'นายสมพงษ์ อิอิ',
        //   position: 'ตำแหน่ง xxxx',
        //   email: 'kookkai@one.th',
        //   userImg: 'https://picsum.photos/200'
        // }
      ],
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
        // v => v.length <= 10 || 'Name must be less than 10 characters'
      ]
    }
  },
  mounted () {
    EventBus.$on('opendialogeditcompany', this.openDialogEditCompany)
    EventBus.$on('addAprover', this.add)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.getSelectCompany()
  },
  computed: {
    imgUser () {
      return this.failed_imageLeader ? require('@/assets/icons/no_user.png') : this.imageUrl
    }
  },
  watch: {
    legalEntityTh: function (val) {
      if (val === 'ห้างหุ่นส่วนสามัญ') {
        this.legalEntityEng = 'Ordinary Partnership'
      } else if (val === 'ห้างหุ่นส่วนจำกัด') {
        this.legalEntityEng = 'Limited Partnership'
      } else if (val === 'บริษัทจำกัด') {
        this.legalEntityEng = 'Company Limited'
      } else if (val === 'บริษัทมหาชนจำกัด') {
        this.legalEntityEng = 'Public Limited Company'
      } else if (val === 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ') {
        this.legalEntityEng = 'Other'
      }
    },
    legalEntityEng: function (val) {
      if (val === 'Ordinary Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนสามัญ'
      } else if (val === 'Limited Partnership') {
        this.legalEntityTh = 'ห้างหุ่นส่วนจำกัด'
      } else if (val === 'Company Limited') {
        this.legalEntityTh = 'บริษัทจำกัด'
      } else if (val === 'Public Limited Company') {
        this.legalEntityTh = 'บริษัทมหาชนจำกัด'
      } else if (val === 'Other') {
        this.legalEntityTh = 'นิติบุคคลอื่นๆ ภายใต้กฎหมายเฉพาะ'
      }
    }
  },
  methods: {
    onImgErrorLeader (event) {
      this.failed_imageLeader = true
    },
    switeAction (value) {
      if (value === true) {
        this.valueAction = false
        this.$forceUpdate()
      } else {
        this.valueAction = true
        this.$forceUpdate()
      }
    },
    closeDialogEdit () {
      this.groupName = ''
      this.companyNameShortTh = ''
      this.companyNameShortEng = ''
      this.legalEntityTh = ''
      this.companyNameFullTh = ''
      this.nameUseInDocTh = ''
      this.legalEntityEng = ''
      this.companyNameFullEng = ''
      this.nameUseInDocEng = ''
      this.taxId = ''
      this.email = ''
      this.region = ''
      this.branchName = ''
      this.branchCode = ''
      this.companyTelNo = ''
      this.companyMobilNumber = ''
      this.fax = ''
      this.companyAddressDetail.codeAddress = ''
      this.companyAddressDetail.address = ''
      this.companyAddressDetail.roomNo = ''
      this.companyAddressDetail.floorNo = ''
      this.companyAddressDetail.buildingName = ''
      this.companyAddressDetail.villageName = ''
      this.companyAddressDetail.villageNo = ''
      this.companyAddressDetail.alley = ''
      this.companyAddressDetail.dispart = ''
      this.companyAddressDetail.road = ''
      this.companyAddressDetail.province = ''
      this.companyAddressDetail.district = ''
      this.companyAddressDetail.subDistrict = ''
      this.companyAddressDetail.postCode = ''
      this.imageUrl = ''
      this.approver = []
      this.filesPoa = []
      this.filesCertificate = []
      this.failed_imageLeader = false
      this.dialogEdit = false
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    checkRemove (item) {
      swal('ต้องการลบผู้อนุมัติคนนี้ ใช่หรือไม่!', {
        buttons: {
          cancel: 'ยกเลิก',
          catch: {
            text: 'ใช่',
            value: 'save'
          }
        }
      })
        .then((value) => {
          switch (value) {
            case 'save':
              this.removeApprover(item)
              break
          }
        })
    },
    removeApprover (item) {
      // console.log('removeApprover', this.approver.indexOf(item))
      this.approver.splice(this.approver.indexOf(item), 1)
      this.userIdList.splice(this.userIdList.indexOf(item), 1)
    },
    removeFile (key, type) {
      if (type === 'certificate') {
        this.filesCertificate.splice(key, 1)
        const input = this.$refs.PickfilesCertificate
        input.type = 'text'
        input.type = 'file'
      } else if (type === 'poa') {
        this.filesPoa.splice(key, 1)
        const input = this.$refs.PickfilesPoa
        input.type = 'text'
        input.type = 'file'
      }
    },
    editCompany (value) {
      this.textTitle = ''
      this.textTitle = value
    },
    async openDialogEditCompany (value, item) {
      this.approver = []
      this.userIdList = []
      this.companyId = item._id
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/companys/getCompanyById`,
        data: {
          companyId: item._id
        }
        // headers: {
        //   authorization: this.tokenUser
        // }
      }).then((response) => {
        this.groupName = response.data.result.groupCompanyId
        this.companyNameShortTh = response.data.result.companyShortNameTh
        this.companyNameShortEng = response.data.result.companyShortNameEng
        this.legalEntityTh = response.data.result.legalEntityTh
        this.companyNameFullTh = response.data.result.companyFullNameTh
        this.nameUseInDocTh = response.data.result.nameUseInDocTh
        this.legalEntityEng = response.data.result.legalEntityEng
        this.companyNameFullEng = response.data.result.companyFullNameEng
        this.nameUseInDocEng = response.data.result.nameUseInDocEng
        this.taxId = response.data.result.taxId
        this.email = response.data.result.email
        this.region = response.data.result.region
        this.branchName = response.data.result.branchName
        this.branchCode = response.data.result.branchCode
        this.companyTelNo = response.data.result.companyTelNo
        this.companyMobilNumber = response.data.result.companyMobilNumber
        this.fax = response.data.result.fax
        this.companyAddressDetail.codeAddress = response.data.result.companyAddressDetail.codeAddress
        this.companyAddressDetail.address = response.data.result.companyAddressDetail.address
        this.companyAddressDetail.roomNo = response.data.result.companyAddressDetail.roomNo
        this.companyAddressDetail.floorNo = response.data.result.companyAddressDetail.floorNo
        this.companyAddressDetail.buildingName = response.data.result.companyAddressDetail.buildingName
        this.companyAddressDetail.villageName = response.data.result.companyAddressDetail.villageName
        this.companyAddressDetail.villageNo = response.data.result.companyAddressDetail.villageNo
        this.companyAddressDetail.alley = response.data.result.companyAddressDetail.alley
        this.companyAddressDetail.dispart = response.data.result.companyAddressDetail.dispart
        this.companyAddressDetail.road = response.data.result.companyAddressDetail.road
        this.companyAddressDetail.province = response.data.result.companyAddressDetail.province
        this.companyAddressDetail.district = response.data.result.companyAddressDetail.district
        this.companyAddressDetail.subDistrict = response.data.result.companyAddressDetail.subDistrict
        this.companyAddressDetail.postCode = response.data.result.companyAddressDetail.postCode
        this.imageUrl = this.api + '/' + response.data.result.companyImage
        const temp = []
        var resultApprover = response.data.result.companyLeader
        resultApprover.map((el, index) => {
          if (el.userImg === '') {
            el.userImg = `${hostImageUrlv3}/_/${el.emailOneId}`
            // console.log('if', el.userImg)
          } else {
            el.userImg = `${hostImageUrlv3}/${el.userImg}/${el.emailOneId}`
            // console.log('else', el.userImg)
          }
          // el.userImg = this.api + '/api/vMonk/reqEmployee/img/' + el.userImg
          el.approverName = el.titleTh + el.firstNameTh + ' ' + el.lastNameTh
          temp.push({
            approverNo: this.approver.length + 1,
            email: el.emailOneId,
            failed_image: false,
            ...el
          })
          this.userIdList.push({
            userId: el._id,
            companyId: el.companyId
          })
          this.approver = temp
        })
        var pathFileName = 'uploads/companyFile/' + this.companyNameFullEng + '/'
        var substringsCertificate = response.data.result.companyCertificate.split(pathFileName, 2)
        var substringsPoa = response.data.result.powerOfAttorney.split(pathFileName, 2)
        this.filesPoa.push({
          name: substringsPoa[1]
        })
        this.filesCertificate.push({
          name: substringsCertificate[1]
        })
        this.approver = response.data.result.companyLeader
        this.dialogEdit = value
      }).catch(e => {
        console.dir(e)
        swal('Error', 'ไม่สำเร็จ!', 'error')
      })
    },
    closeDialogCreate () {
      this.dialogCreate = false
      EventBus.$emit('closedialogcreate', this.dialogCreate)
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      }).then((response) => {
        // console.log('Get Edit List', response.data.result)
        var dataReverse = response.data.result
        this.itemCompany = dataReverse
        // console.log('reverse', this.itemCompany)
        this.itemCompany.push({
          _id: '',
          groupCompanyNameEng: 'ไม่มี'
        })
        this.itemCompany = this.itemCompany.reverse()
      }).catch(e => {
        // console.log(e)
      })
    },
    async getUserDefault () {
      this.loading = true
      this.loadingUsers = true
      const obj = {
        search: this.$store.state.user.employeeId
      }
      try {
        const res = await getUserByKeyword(obj, this.tokenUser)
        if (res.success) {
          var filterValue = this.approver.filter(r => {
            if (r._id === res.result[0].id && r.employeeId === res.result[0].employeeId) {
              return r
            }
          })
          if (filterValue.length > 0) {
            swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
          } else {
            // console.log('No Dup', filterValue)
            this.approver.push({
              approverNo: this.approver.length + 1,
              _id: res.result[0].id,
              employeeId: res.result[0].employeeId,
              approverName: res.result[0].name,
              position: res.result[0].position.positionName,
              email: res.result[0].email,
              userImg: this.api + '/' + res.result[0].userImg,
              approveType: res.result[0].approveType,
              failed_image: false
            })
            this.userIdList.push({
              userId: res.result[0].id,
              companyId: res.result[0].companyId
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
        this.loadingUsers = false
      }
    },
    async getFormAuth () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจ.doc')
      }).catch(e => {
        console.log(e)
      })
    },
    async getFormPoa () {
      await this.axios({
        method: 'get',
        responseType: 'blob',
        url: `${this.api}/api/vMonk/companys/downloadSPOA`
      }).then((response) => {
        FileSaver.saveAs(new Blob([response.data]), 'หนังสือมอบอำนาจช่วง.docx')
      }).catch(e => {
        console.log(e)
      })
    },
    openDialogAddAprover (action, item, index) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index)
    },
    getCompanyRefresh (value) {
      EventBus.$emit('companylistrefresh', value)
    },
    add (value, index, action) {
      var filterValue = this.approver.filter(r => {
        if (r.position === value.position && r._id === value.id && r.employeeId === value.employeeId) {
          return r
        }
      })
      if (action === 'add') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.approver.push({
            approverNo: this.approver.length + 1,
            _id: value.id,
            employeeId: value.employeeId,
            approverName: value.name,
            position: value.position,
            email: value.email,
            userImg: value.userImg,
            approveType: value.approveType,
            failed_image: false
          })
          this.userIdList.push({
            userId: value.id,
            companyId: value.companyId
          })
        }
      } else if (action === 'edit') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คูณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.approver[index].approverNo = index + 1
          this.approver[index]._id = value.id
          this.approver[index].employeeId = value.employeeId
          this.approver[index].approverName = value.name
          this.approver[index].position = value.position
          this.approver[index].email = value.email
          this.approver[index].approveType = value.approveType
          this.approver[index].userImg = value.userImg
          this.approver[index].failed_image = value.failed_image || false
        }
      }
    },
    async submitEdit (preName) {
      this.$refs.form.validate()
      var formData = new FormData()
      formData.append('image', this.files[0])
      formData.append('certificate', this.filesCertificate[0])
      formData.append('powerOfAttorney', this.filesPoa[0])
      formData.append('groupCompanyId', this.groupName)
      formData.append('companyFullNameEng', this.companyNameFullEng)
      formData.append('companyFullNameTh', this.companyNameFullTh)
      formData.append('companyShortNameTh', this.companyNameShortTh)
      formData.append('companyShortNameEng', this.companyNameShortEng)
      formData.append('legalEntityTh', this.legalEntityTh)
      formData.append('legalEntityEng', this.legalEntityEng)
      formData.append('nameUseInDocTh', this.nameUseInDocTh)
      formData.append('nameUseInDocEng', this.nameUseInDocEng)
      formData.append('taxId', this.taxId)
      formData.append('email', this.email)
      formData.append('branchName', this.branchName)
      formData.append('branchCode', this.branchCode)
      formData.append('companyTelNo', this.companyTelNo)
      formData.append('companyMobilNumber', this.companyMobilNumber)
      formData.append('fax', this.fax)
      formData.append('companyAddressDetail', JSON.stringify(this.companyAddressDetail))
      formData.append('companyLeader', JSON.stringify(this.userIdList))
      formData.append('region', this.region)
      if (this.companyNameShortTh === '' ||
      this.companyNameShortEng === '' ||
      this.legalEntityTh === '' ||
      this.companyNameFullTh === '' ||
      this.nameUseInDocTh === '' ||
      this.legalEntityEng === '' ||
      this.companyNameFullEng === '' ||
      this.nameUseInDocEng === '' ||
      this.taxId === '' ||
      this.email === '' ||
      this.region === '' ||
      this.branchName === '' ||
      this.branchCode === '' ||
      this.companyMobilNumber === '' ||
      this.companyAddressDetail.address === '' ||
      this.companyAddressDetail.province === '' ||
      this.companyAddressDetail.district === '' ||
      this.companyAddressDetail.subDistrict === '' ||
      this.companyAddressDetail.postCode === '') {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/companys/updateCompany/` + this.companyId,
          data: formData,
          headers: {
            authorization: this.tokenUser
          }
        }).then((response) => {
          swal('สำเร็จ', 'แก้ไขบริษัท สำเร็จ', 'success', {
            button: false,
            timer: 2000
          })
          this.dialogEdit = false
          this.preName = ''
          // this.getCompanyLists()
          this.closeDialogEdit()
          this.getCompanyRefresh(true)
        }).catch(e => {
          console.dir(e)
          swal('ผิดพลาด', 'แก้ไขบริษัท ไม่สำเร็จ!', 'error')
        })
      }
    },
    addFiles (type) {
      if (type === 'certificate') {
        this.$refs.PickfilesCertificate.click()
        // console.log('add files', this.$refs.PickfilesCertificate)
      } else if (type === 'poa') {
        this.$refs.PickfilesPoa.click()
      }
    },
    onFileSelected (type) {
      if (type === 'certificate') {
        this.filesCertificate = []
        var uploadedFilesCertificate = this.$refs.PickfilesCertificate.files
        for (let i = 0; i < uploadedFilesCertificate.length; i++) {
          var dotindexCertificate = uploadedFilesCertificate[i].name.lastIndexOf('.')
          var FileExtension = uploadedFilesCertificate[i].name.substr(dotindexCertificate + 1).toLowerCase()
          if (FileExtension === 'pdf') {
            this.filesCertificate.push(uploadedFilesCertificate[i])
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesCertificate[i].name.substr(-4)}`, 'warning')
          }
        }
      } else if (type === 'poa') {
        this.filesPoa = []
        var uploadedFilesPoa = this.$refs.PickfilesPoa.files
        for (let i = 0; i < uploadedFilesPoa.length; i++) {
          var dotindexPoa = uploadedFilesPoa[i].name.lastIndexOf('.')
          var FileExtensionPoa = uploadedFilesPoa[i].name.substr(dotindexPoa + 1).toLowerCase()

          if (FileExtensionPoa === 'pdf') {
            this.filesPoa.push(uploadedFilesPoa[i])
            // console.log('File', this.filesPoa)
          } else {
            swal('คำเตือน', `ไม่รองรับไฟล์${uploadedFilesPoa[i].name.substr(-4)}`, 'warning')
          }
        }
      }
      // console.log('filesss', this.filesPoa)
    },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name.substr(dotindex + 1).toLowerCase()
      if (FileExtension === 'jpg' || FileExtension === 'png' || FileExtension === 'JPG' || FileExtension === 'PNG') {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var img = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          img.src = evt.target.result
        }
        // reader.onerror = evt => {
        //   console.error(evt)
        // }
      } else {
        swal('คำเตือน', `ไม่รองรับไฟล์${uploadedImage[0].name.substr(-4)}`, 'warning')
      }
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.base-image-input {
  display: block;
  width: 200px;
  height: 200px;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
/* src\assets\logo.png */
.placeholder {
  /* background: #F0F0F0; */
  background-image: url('../../assets/icons/add_company2.png');
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
  font-family: 'Sarabun', sans-serif;
}
.placeholder:hover {
  /* background: #E0E0E0; */
  background-image: url('../../assets/icons/add_company2.png');

}
.file-input {
  display: none;
}
.box-image1 {
  border: 1px solid rgba(0, 0, 0, 0.4);
  outline: none;
  color: rgb(118, 118, 118);
  /* display: flex; */
  align-content: center;
  justify-content: center;
  display: grid;
  height: 70%;
  text-align: center;
}
.box-image2 {
  border: dashed;
  border-width: 1px 1px;
  border-radius: 10px;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
</style>
